import React from 'react';

export const VendedorContactCards = ({ vendedor }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-testid="vendedor-contact-cards-grid">
      {vendedor.whatsapp && (
        <a
          href={`https://wa.me/${vendedor.whatsapp.replace(/\D/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 text-white rounded-xl p-4 flex items-center gap-3 hover:bg-green-600 transition"
          data-testid="vendedor-whatsapp-link"
        >
          <span className="text-2xl">📱</span>
          <div>
            <div className="font-semibold" data-testid="vendedor-whatsapp-title">WhatsApp</div>
            <div className="text-sm opacity-90" data-testid="vendedor-whatsapp-subtitle">Clique para conversar</div>
          </div>
        </a>
      )}

      {vendedor.telefone && (
        <a href={`tel:${vendedor.telefone}`} className="bg-blue-500 text-white rounded-xl p-4 flex items-center gap-3 hover:bg-blue-600 transition" data-testid="vendedor-phone-link">
          <span className="text-2xl">📞</span>
          <div>
            <div className="font-semibold" data-testid="vendedor-phone-title">Ligar</div>
            <div className="text-sm opacity-90" data-testid="vendedor-phone-value">{vendedor.telefone}</div>
          </div>
        </a>
      )}

      {vendedor.email && (
        <a href={`mailto:${vendedor.email}`} className="bg-purple-500 text-white rounded-xl p-4 flex items-center gap-3 hover:bg-purple-600 transition" data-testid="vendedor-email-link">
          <span className="text-2xl">✉️</span>
          <div>
            <div className="font-semibold" data-testid="vendedor-email-title">Email</div>
            <div className="text-sm opacity-90" data-testid="vendedor-email-subtitle">Enviar mensagem</div>
          </div>
        </a>
      )}
    </div>
  );
};
